
import Vue from 'vue'
import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import * as Api from '@/api/PartyIdentityUserApi'

import { PageHeader } from '../components'
import { TextDisplay, DateDisplay } from '@/components/formGroups'
import UserActions from '../components/user/PillStack.vue'

export default Vue.extend({
   name: 'UserDetails',
   props: { schoolId: String, userId: String },
   data() {
      return {
         editingItem: {} as PartyIdentityUserDto,
      }
   },
   computed: {
      crumbs(): Breadcrumb[] {
         return [
            {
               text: this.schoolId ? 'School Users' : 'All Users',
               route: 'user-list',
               params: this.schoolId ? { schoolId: this.schoolId } : {},
            },
            { text: this.editingItem ? this.editingItem.UserName : '' },
         ]
      },
   },
   mounted() {
      this.loadItem()
   },
   methods: {
      async loadItem() {
         const item = await Api.getPartyIdentityUser(this.userId)
         Vue.$assign(this.editingItem, item)
      },
   },
   components: {
      PageHeader,
      UserActions,
      TextDisplay,
      DateDisplay,
   },
})
